import React from 'react'

// PropTypes
import PropTypes from 'prop-types'
import {project_info_t} from '../etc/common-props'

// Helpers
import {dateFormatter} from '../etc/formatters'

// Material UI
import Typography from 'material-ui/Typography'

import { withStyles } from 'material-ui/styles'
import frameworkStyles from './FrameworkStyles'

// let styles = theme => ({
//   root: {
//     textAlign: 'left',
//     marginRight: theme.spacing.unit * 3,
//     marginLeft: 0    
//   }

// })

let ProjectInfo = ({dataset, className}) => {

  if (!dataset)
  {
    return ''
  }

  let {title, subtitle, status_date} = dataset

  return (
  <div className={className}>
    <Typography type="body1" color="inherit">
      {title}
    </Typography>
    <Typography type="body1" color="inherit">
      {subtitle}
    </Typography>
    <Typography type="caption" color="inherit">
      {`Status Date: ${dateFormatter.calendarDate(status_date)}`}
    </Typography>

  </div>
)}

ProjectInfo.propTypes = {
  // classes: PropTypes.object,
  dataset: project_info_t
}

export default ProjectInfo
// export default withStyles(styles)(ProjectInfo)




// WEBPACK FOOTER //
// ./src/components/ProjectInfo.js